export const environment = {
    production: false,
    version: '1.0-dev',
    defaultLanguage: 'en-US',
    supportedLanguages: ['en-US'],
    apiBaseUrl: "https://api-test.aesc-visitor-registration.com/api/v1",
    auth: {
        issuer: "https://somebuddy-dev.eu.auth0.com/",
        audience: 'https://mercury-api.yantech.dk/api/v1',
        clientId: "GH2jWUrlnneyiWrgxKcfoEca0pG5b6ut",
        scope: "openid profile email",
        silentRefreshTimeout: 5000,
        timeoutFactor: 500,
        showDebugInformation: true
    }
};